<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="name"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Dorm Name</label>
              <md-input v-model="name" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="address"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Address</label>
              <md-input v-model="address" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
        <!--            <ValidationProvider-->
        <!--              name="main_user"-->
        <!--              v-slot="{ passed, failed }"-->
        <!--            >-->
        <!--              <md-field-->
        <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
        <!--              >-->
        <!--                <md-icon>add_location</md-icon>-->
        <!--                <label>Main User</label>-->
        <!--                <md-select v-model="main_user" name="main_user">-->
        <!--                  <md-option value="">Select Main User</md-option>-->
        <!--                  <md-option v-for="c in main_users" v-bind:key="c.id" :value="c.id">{{ c.first_name }} {{ c.last_name }}</md-option>-->
        <!--                </md-select>-->

        <!--              </md-field>-->
        <!--            </ValidationProvider>-->
        <!--        </div>-->

        <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
        <!--          <ValidationProvider-->
        <!--            name="end_date"-->
        <!--            v-slot="{ passed, failed }"-->
        <!--          >-->
        <!--            <md-datepicker :class="[{ 'md-error': failed }, { 'md-valid': passed }]" v-model="end_date" md-immediately>-->
        <!--              <label>End Date</label>-->
        <!--              <slide-y-down-transition>-->
        <!--                <md-icon class="error" v-show="failed">close</md-icon>-->
        <!--              </slide-y-down-transition>-->
        <!--              <slide-y-down-transition>-->
        <!--                <md-icon class="success" v-show="passed">done</md-icon>-->
        <!--              </slide-y-down-transition>-->
        <!--            </md-datepicker>-->

        <!--          </ValidationProvider>-->
        <!--        </div>-->

        <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
        <!--            <ValidationProvider-->
        <!--              name="country"-->
        <!--              v-slot="{ passed, failed }"-->
        <!--            >-->
        <!--              <md-field-->
        <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
        <!--              >-->
        <!--                <md-icon>add_location</md-icon>-->
        <!--                <label>Country</label>-->
        <!--                <md-select v-model="country" name="country">-->
        <!--                  <md-option value="">Select Country</md-option>-->
        <!--                  <md-option v-for="c in countries" v-bind:key="c.id" :value="c.id">{{ c.name }}</md-option>-->
        <!--                </md-select>-->

        <!--              </md-field>-->
        <!--            </ValidationProvider>-->
        <!--        </div>-->

        <!--        <div class="md-layout-item md-size-50 md-small-size-100">-->
        <!--          <ValidationProvider-->
        <!--              name="email"-->
        <!--              v-slot="{ passed, failed }"-->
        <!--            >-->
        <!--              <md-field-->
        <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
        <!--              >-->
        <!--                <md-icon>attach_money</md-icon>-->
        <!--                <label>Email</label>-->
        <!--                <md-input v-model="email" type="text"> </md-input>-->

        <!--                <slide-y-down-transition>-->
        <!--                  <md-icon class="error" v-show="failed">close</md-icon>-->
        <!--                </slide-y-down-transition>-->
        <!--                <slide-y-down-transition>-->
        <!--                  <md-icon class="success" v-show="passed">done</md-icon>-->
        <!--                </slide-y-down-transition>-->

        <!--              </md-field>-->
        <!--            </ValidationProvider>-->
        <!--        </div>-->

        <!--        <div class="md-layout-item md-size-50 md-small-size-100">-->
        <!--          <ValidationProvider-->
        <!--              name="phone"-->
        <!--              rules="numeric"-->
        <!--              v-slot="{ passed, failed }"-->
        <!--            >-->
        <!--              <md-field-->
        <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
        <!--              >-->
        <!--                <md-icon>article</md-icon>-->
        <!--                <label>Phone</label>-->
        <!--                <md-input v-model="phone" type="text"> </md-input>-->

        <!--                <slide-y-down-transition>-->
        <!--                  <md-icon class="error" v-show="failed">close</md-icon>-->
        <!--                </slide-y-down-transition>-->
        <!--                <slide-y-down-transition>-->
        <!--                  <md-icon class="success" v-show="passed">done</md-icon>-->
        <!--                </slide-y-down-transition>-->

        <!--              </md-field>-->
        <!--            </ValidationProvider>-->
        <!--        </div>-->

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider name="lat" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Latitude</label>
              <md-input v-model="lat" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider name="long" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Longitude</label>
              <md-input v-model="long" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    avatar: {
      type: String,
      default: "/img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      countries: [],
      main_users: [],

      name: null,
      address: null,
      main_user: null,
      country: null,
      end_date: null,
      email: null,
      phone: null,
      lat: null,
      long: null
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit("on-validated", res);
        return res;
      });
    }
  },
  mounted() {
    // this.$store.getCountries().then(response => {
    //   this.countries = response.data.results
    // }).catch(error => {
    //   this.$notify({
    //     message: error.message,
    //     icon: 'add_alert',
    //     type: "warning",
    //     verticalAlign: "top",
    //   })
    // })
    // var params = {role: 5} // dorm users
    // this.$store.getUsers(params).then(response => {
    //   this.main_users = response.data.results
    // }).catch(error => {
    //   this.$notify({
    //     message: error.message,
    //     icon: 'add_alert',
    //     type: "warning",
    //     verticalAlign: "top",
    //   })
    // })
  }
};
</script>
<style></style>
